import { render } from "./OrderRemake.vue?vue&type=template&id=abf6a5a0&scoped=true"
import script from "./OrderRemake.vue?vue&type=script&lang=js"
export * from "./OrderRemake.vue?vue&type=script&lang=js"

import "./OrderRemake.vue?vue&type=style&index=0&id=abf6a5a0&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abf6a5a0"]])

export default __exports__